module.exports = __webpack_public_path__ + "officialStatic/img/case45.eb789b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case45.jpg
// module id = SpWG
// module chunks = 0